import React from 'react';
import { H1, H3 } from '~typography';
import { LinkButton } from '~button';
import CtaButton from './CtaButton';
import commercePropTypes from '../../prop-types/commercePropTypes';

var Description = function Description(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      to = _ref.to,
      ctaLabel = _ref.ctaLabel,
      ctaBtn = _ref.ctaBtn;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H1, null, title), /*#__PURE__*/React.createElement(H3, null, subtitle), to && ctaLabel && /*#__PURE__*/React.createElement(CtaButton, null, /*#__PURE__*/React.createElement(LinkButton, {
    to: to,
    btnType: ctaBtn === null || ctaBtn === void 0 ? void 0 : ctaBtn.btnType,
    skin: ctaBtn === null || ctaBtn === void 0 ? void 0 : ctaBtn.skin,
    size: ctaBtn === null || ctaBtn === void 0 ? void 0 : ctaBtn.size
  }, ctaLabel)));
};

Description.defaultProps = {
  title: undefined,
  subtitle: undefined,
  to: undefined,
  ctaLabel: undefined,
  ctaBtn: undefined
};
export default Description;